import React from "react";
import { Navigate } from "react-router-dom";
import Cookies from "js-cookie";
const AuthGuard = ({ children }) => {
  const storedAddress = Cookies.get("connectedAddress");
  const isLoggedIn = storedAddress !== undefined;
  return isLoggedIn === true ? children : <Navigate to="/" replace />;
};
export default AuthGuard;